import * as E from 'fp-ts/Either';
import * as Err from '@fixtuur/error-context';
import { pipe } from 'fp-ts/lib/function';
import * as TE from 'fp-ts/TaskEither';
import * as i from 'io-ts';
import * as OptionsRequests from '../../requests/configuration/options';
import { Name, Value } from './option';
/**
 * Collects the option values per name given some set of items
 * (where items are either a product or a particle)
 */
export const Options = i.record(Name, i.array(Value));
// Internal Only - A Codec for the Response that comes back from the API
const OptionsFromApiResponse = new i.Type('OptionsFromApiResponse', Options.is, (input, context) => pipe(input, x => i.type({ properties: Options }).validate(x, context), E.map(x => x.properties)), JSON.stringify);
export var _FromProductError;
(function (_FromProductError) {
    _FromProductError["RequestError"] = "A Request Error Occured";
    _FromProductError["DecodeError"] = "An Error Decoding the Response Occured";
})(_FromProductError || (_FromProductError = {}));
export const fromGroupingCode = (config, groupingCode, selections) => {
    return pipe(OptionsRequests.getFromProductGroupingCode(config, groupingCode, selections), TE.mapLeft(Err.swap(_FromProductError.RequestError)), TE.chain(response => pipe(response.data, OptionsFromApiResponse.decode, E.mapLeft(err => Err.construct(_FromProductError.DecodeError, {
        // TODO: format validation errors properly
        originalErrors: JSON.stringify(err),
    })), TE.fromEither)));
};
export var _FromConfigurationSpaceError;
(function (_FromConfigurationSpaceError) {
    _FromConfigurationSpaceError["RequestError"] = "A Request Error Occured";
    _FromConfigurationSpaceError["DecodeError"] = "An Error Decoding the Response Occured";
})(_FromConfigurationSpaceError || (_FromConfigurationSpaceError = {}));
export const fromConfigurationSpace = (config, configurationSpaceId, selections) => {
    return pipe(OptionsRequests.getFromConfigurationSpace(config, configurationSpaceId, selections), TE.mapLeft(Err.swap(_FromConfigurationSpaceError.RequestError)), TE.chain(response => pipe(response.data, OptionsFromApiResponse.decode, E.mapLeft(err => Err.construct(_FromConfigurationSpaceError.DecodeError, {
        originalErrors: JSON.stringify(err),
    })), TE.fromEither)));
};
export const stringValuesFromProperty = (property, options) => options[property]?.filter(i.string.is) ?? [];
